/**
 * 
 */
class Styles {

	/**
	 * @type HTMLStyleElement
	 */
	element = null;

	/**
	 * @type Object
	 */
	entries = {};

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{

	}

	/**
	 * 
	 */
	setup()
	{
		this.element = document.createElement( 'style' );
		this.element.setAttribute( 'type', 'text/css' );
		document.querySelector( 'head' ).appendChild( this.element );
	}

	/**
	 * 
	 * @param {String} index 
	 * @param {String} entry 
	 */
	updateEntry( index, entry )
	{
		if ( ! this.entries[ index ] || this.entries[ index ] !== entry )
		{
			this.entries[ index ] = entry;
			this.write();
		}
	}

	/**
	 * 
	 */
	write()
	{
		if ( null === this.element ) return;

		this.element.innerHTML = "";

		for ( const key of Object.getOwnPropertyNames( this.entries ) )
		{
			this.element.innerHTML += this.entries[ key ];
		}
	}

}

export default Styles;